
import blog from '~/graphql/queries/blog';
import meta from '~/plugins/mixins/meta';

export default {
  auth: false,
  mixins: [meta],
  apollo: {
    blog: {
      query: blog,
      prefetch: ({route}) => ({slug: route.params.slug}),
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({data: {blog}}) {
        if (!blog) {
          this.$nuxt.error({statusCode: 404, message: 'Blog niet gevonden'});
        }
      },
    },
  },
  data: () => ({
    blog: {},
  }),
  computed: {
    headerImage() {
      if (this.blog.beeld.length) {
        return this.blog.beeld[0].url;
      }

      if (this.blog.image) {
        return this.blog.image.url;
      }

      return null;
    },
  },
  head() {
    return this.getMeta(this.blog);
  },
};
